// 第二引数に1を渡すと小数点以下第一位まで表示される（第二位が丸められる）
export const getFloatNumberRoundValue = (baseNumber: number, decimalPlaces: number) => {
  return Math.round(baseNumber * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
};
